
export interface OGMetaTags {
    url: Element,
    type: Element,
    title: Element,
    description: Element,
    image: Element,
    author: Element,
}

export function setDefaultSharingData(sharingData){
    const OGmetaTags: OGMetaTags = getOGMetaTags();
    OGmetaTags.url.setAttribute('content', sharingData.host_url);
    OGmetaTags.title.setAttribute('content', sharingData.default_title);
    OGmetaTags.description.setAttribute('content', sharingData.default_description);
    OGmetaTags.image.setAttribute('content', sharingData.image);
    OGmetaTags.author.setAttribute('content', sharingData.author);
}

export function getOGMetaTags(){

    return {
        url: document.querySelector('meta[property="og:url"]') ?? createMetaTag('url'),
        type: document.querySelector('meta[property="og:type"]') ?? createMetaTag('type'),
        title: document.querySelector('meta[property="og:title"]') ?? createMetaTag('url'),
        description: document.querySelector('meta[property="og:description"]') ?? createMetaTag('description'),
        image: document.querySelector('meta[property="og:image"]') ?? createMetaTag('image'),
        author: document.querySelector('meta[property="og:author"]') ?? createMetaTag('author'),
    };
}

function createMetaTag(name){
    const head = document.getElementsByTagName('head')[0];
    let e = document.createElement('meta');
    e.setAttribute('id', `og_${name}`);
    e.setAttribute('property', `og:${name}`);
    e.setAttribute('content', '');
    head.appendChild(e);
    return e;
}
